export default "//file.bilionpass.com/japandx-portal/0.1.23/static/img/mission.f822ba70-d13bcb.png";